
import { defineComponent, PropType } from 'vue';
import { B2CCreateProfileConfirmationHeroTileModel } from '@/types/B2CcontentServerContract';
import CreateProfileSuccess from '@/b2c/profile/ui/CreateProfileSuccess.vue';

export default defineComponent({
    name: 'B2CCreateProfileConfirmationHeroTile',
    components: { CreateProfileSuccess },
    props: {
        content: {
            type: Object as PropType<B2CCreateProfileConfirmationHeroTileModel>,
            required: true,
        },
    },
});
